export default __webpack_public_path__ + "static/media/080_finish_soso.last.a156c4a1.png";